import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import './LoadingProgress.css';

const LoadingProgress = ({ current, total, isInitialLoad }) => {
    const percentage = total === 'unknown' ? 0 : Math.round((current / total) * 100);

    return (
        <div className="loading-progress">
            <div className="loading-header">
                <FontAwesomeIcon icon={faSpinner} spin />
                <span>{isInitialLoad ? 'Loading initial items...' : 'Loading more items...'}</span>
            </div>
            {total !== 'unknown' && (
                <>
                    <div className="progress-bar">
                        <div 
                            className="progress-fill" 
                            style={{ width: `${percentage}%` }}
                        />
                    </div>
                    <div className="progress-stats">
                        <span>{current} items loaded</span>
                        <span>{percentage}%</span>
                    </div>
                </>
            )}
        </div>
    );
};

export default LoadingProgress; 